(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-floating-buttons]').forEach((root) => {
      if (root.dataset.fbInit === 'true') return;
      root.dataset.fbInit = 'true';

      const triggers = Array.from(root.querySelectorAll('[data-fb-trigger]'));
      const sectionId = root.id.replace('FloatingButtons-', '');
      const sectionModals = Array.from(document.querySelectorAll('[data-fb-modal]')).filter((modal) => {
        if (!modal.id) return false;
        if (modal.id === `FloatingButtonsModal-${sectionId}`) return true;
        if (
          (modal.id.startsWith('FloatingShareModal-') || modal.id.startsWith('FloatingProductModal-')) &&
          root.querySelector(`[data-fb-target="${modal.id}"]`)
        ) {
          return true;
        }
        return root.contains(modal);
      });

      sectionModals.forEach((modal) => {
        if (modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }
      });

      let closingTimer = null;
      let activeTrigger = null;
      let activeModal = null;
      let activeDialog = null;

      const getButtonDelta = (trigger) => {
        const triggerRect = trigger.getBoundingClientRect();
        const btnX = triggerRect.left + triggerRect.width / 2;
        const btnY = triggerRect.top + triggerRect.height / 2;
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;
        return { x: btnX - centerX, y: btnY - centerY };
      };

      const setStartFromButton = (trigger, dialog) => {
        const { x, y } = getButtonDelta(trigger);
        dialog.style.transition = 'none';
        dialog.style.transformOrigin = 'center center';
        dialog.style.transform = `translate(${x}px, ${y}px) scale(0.08)`;
        dialog.style.opacity = '0';
        void dialog.offsetWidth;
      };

      const setEndAtCenter = (dialog) => {
        dialog.style.transition = '';
        dialog.style.transform = 'translate(0, 0) scale(1)';
        dialog.style.opacity = '1';
      };

      const closeModal = () => {
        if (!activeModal || (!activeModal.classList.contains('is-open') && activeModal.hidden)) return;

        const trigger = activeTrigger;
        const modal = activeModal;
        const dialog = activeDialog;
        const { x, y } = getButtonDelta(trigger || root.querySelector('[data-fb-trigger]'));

        modal.classList.remove('is-open');
        if (dialog) {
          dialog.style.transform = `translate(${x}px, ${y}px) scale(0.08)`;
          dialog.style.opacity = '0';
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('floating-buttons-open');

        closingTimer = window.setTimeout(() => {
          if (!modal.classList.contains('is-open')) {
            modal.hidden = true;
            if (dialog) {
              dialog.style.transform = '';
              dialog.style.opacity = '';
              dialog.style.transition = '';
            }
          }
          if (activeModal === modal) {
            activeTrigger = null;
            activeModal = null;
            activeDialog = null;
          }
          closingTimer = null;
        }, 360);
      };

      const openModal = (trigger) => {
        const targetId = trigger.getAttribute('data-fb-target');
        const modal = targetId ? document.getElementById(targetId) : null;
        const dialog = modal ? modal.querySelector('[data-fb-dialog]') : null;
        if (!modal || !dialog) return;

        if (closingTimer) {
          clearTimeout(closingTimer);
          closingTimer = null;
        }

        if (activeModal && activeModal !== modal) {
          activeModal.classList.remove('is-open');
          activeModal.hidden = true;
          if (activeTrigger) activeTrigger.setAttribute('aria-expanded', 'false');
        }

        activeTrigger = trigger;
        activeModal = modal;
        activeDialog = dialog;

        modal.hidden = false;
        modal.classList.remove('is-open');
        setStartFromButton(trigger, dialog);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            modal.classList.add('is-open');
            setEndAtCenter(dialog);
          });
        });

        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('floating-buttons-open');
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const targetId = trigger.getAttribute('data-fb-target');
          if (activeModal && activeModal.id === targetId && activeModal.classList.contains('is-open')) {
            closeModal();
          } else {
            openModal(trigger);
          }
        });
      });

      sectionModals.forEach((modal) => {
        modal.querySelectorAll('[data-fb-close]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            closeModal();
          });
        });

        modal.querySelectorAll('[data-fb-share-copy]').forEach((btn) => {
          btn.addEventListener('click', async (event) => {
            event.preventDefault();
            const box = btn.closest('.floating-buttons__share-box') || modal;
            const input = box.querySelector('[data-fb-share-input]');
            const value = input ? input.value : window.location.href;
            const original = btn.textContent;
            const copiedLabel = btn.getAttribute('data-copied-label') || 'COPIED';

            try {
              await navigator.clipboard.writeText(value);
            } catch (err) {
              if (input) {
                input.select();
                document.execCommand('copy');
              }
            }

            btn.textContent = copiedLabel;
            window.setTimeout(() => {
              btn.textContent = original;
            }, 1500);
          });
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeModal();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-floating-buttons]');
    if (root) delete root.dataset.fbInit;
    init(event.target);
  });
})();
